import { createSlice } from "@reduxjs/toolkit";
import {
  createSession,
  getUserBySession,
  joinSession,
  getSessionById,
  getUserById,
  updateEmotionStatus,
} from "../actions/sessionAction";

const initialState = {
  isLoading: false,
  points: 0,
  isError: false,
  sessionData: {},
  sessionCreater: null,
  isEmotionActive: {
    status: true,
    name: null,
    id: null,
  },
  isCloseSession: false,
  lastQuestionAsked: null,
  isUserContinueAgainAfterSessionClose: false,
  navOpen: false,
  isTogleHide: false,
  lastSummaryRating: null,
};

export const createSessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    resetSessionState: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.isCloseSession = false;
      state.lastQuestionAsked = null;
      state.isEmotionActive = {
        ...state.isEmotionActive,
        name: "",
        status: true,
        id: null,
      };
      state.isUserContinueAgainAfterSessionClose = false;
      state.sessionCreater = {};
      state.points = 0;
      state.sessionData = {};
    },
    updateSessionData: (state, { payload }) => {
      state.sessionData = payload;
    },
    updateIsCloseSession: (state, { payload }) => {
      state.isCloseSession = payload;
    },
    updateLastQuestionAsked: (state, { payload }) => {
      state.lastQuestionAsked = payload;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    isNavOpen: (state, { payload }) => {
      state.navOpen = payload;
    },
    setToggleHide: (state, { payload }) => {
      state.isTogleHide = payload;
    },
    updateLastSummaryRating: (state, { payload }) => {
      state.lastSummaryRating = payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(createSession.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createSession.fulfilled, (state, { payload }) => {
      localStorage.setItem("currentUser", JSON.stringify({ ...payload }));
      state.sessionData = {
        ...state.sessionData,
        sender: payload,
        session_id: payload.session_id,
        sessionId: payload.session_ID,
      };
    });
    builder.addCase(createSession.rejected, (state) => {
      state.isError = true;
      state.isLoading = false;
    });

    //*****************************join session
    builder.addCase(joinSession.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(joinSession.fulfilled, (state, { payload }) => {
      const { sender, ...rest } = payload;
      localStorage.setItem("currentUser", JSON.stringify({ ...rest }));
      state.sessionData = { ...state.sessionData, sender: payload };
    });
    builder.addCase(joinSession.rejected, (state) => {
      state.isError = true;
      state.isLoading = false;
    });

    //*******************************Get user by session
    builder.addCase(getUserBySession.pending, (state, { payload }) => {
      state.isLoading = true;
    });
    builder.addCase(getUserBySession.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.sessionCreater = payload;
    });
    builder.addCase(getUserBySession.rejected, (state, { error }) => {
      state.isError = true;
    });

    //*********************************get user session by id
    builder.addCase(getSessionById.pending, (state, { payload }) => {
      state.isLoading = true;
    });
    builder.addCase(getSessionById.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      // state.sessionDetials = payload;
    });
    builder.addCase(getSessionById.rejected, (state, { error }) => {
      state.isError = true;
    });

    //*********************************get user session by id
    builder.addCase(getUserById.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUserById.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      if (payload && payload.points !== undefined) {
        state.points = payload.points;
      } else {
        state.points = 0;
      }
    });
    builder.addCase(getUserById.rejected, (state, { error }) => {
      state.isLoading = false;
      state.isError = true;
    });
    //*********************************emotion status
    builder.addCase(updateEmotionStatus.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateEmotionStatus.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.isEmotionActive = payload;
    });
    builder.addCase(updateEmotionStatus.rejected, (state, { error }) => {
      alert("fff");
      state.isLoading = false;
      state.isError = true;
    });
  },
});
export const {
  setToggleHide,
  isNavOpen,
  updateSessionData,
  resetSessionState,
  updateIsCloseSession,
  updateLastQuestionAsked,
  stopLoading,
  updateIsUserContinueAgainAfterSessionClose,
  updateLastSummaryRating,
} = createSessionSlice.actions;

export default createSessionSlice.reducer;
